export enum EventActionEnum {
  "MOVEMENT" = "MOVEMENT",
  "STOP_ACTION_MODAL_PROGRESS" = "STOP_ACTION_MODAL_PROGRESS",
  "NULL" = "NULL",
}
